//translation
import {tl} from "framework/utils/Translator"
import Cookies from 'js-cookie'

// @material-ui/icons
import CloudIcon from "@material-ui/icons/Cloud";
import CloudCircleIcon from "@material-ui/icons/CloudCircle";
import AppIcon from "@material-ui/icons/WebAsset";
import AppReleaseIcon from "@material-ui/icons/Sync";

//activities
import SaasClientActivity from 'app/modules/Saas/activities/SaasClientActivity'
import AppReleaseActivity from 'app/modules/Saas/activities/AppReleaseActivity'
import AppActivity from "app/modules/Saas/activities/AppActivity";

var Routes = [
    {
    	collapse	: true,
	    name		: tl(Cookies.get("lang"),"Saas"),
	    menu		: "SAAS",
	    icon 		: CloudIcon,
	    state		: "SAAS",
	    views		:[
			{
				path		: "/saas-client/:id?",
				name		: tl(Cookies.get("lang"),"SaasClient"),
				menu		: "SAAS01",
				icon 		: CloudCircleIcon,
				component 	: SaasClientActivity,
				layout		: "/admin"
			},
			{
				path		: "/app/:id?",
				name		: tl(Cookies.get("lang"),"App"),
				menu		: "SAAS02",
				icon 		: AppIcon,
				component 	: AppActivity,
				layout		: "/admin"
			},
			{
				path		: "/app-release/:id?",
				name		: tl(Cookies.get("lang"),"AppRelease"),
				menu		: "SAAS03",
				icon 		: AppReleaseIcon,
				component 	: AppReleaseActivity,
				layout		: "/admin"
			},
		]
	},
]

export default Routes